<template>
  <div class="select-container">
    <transition name="fade-in">
      <div
        ref="cover"
        class="bg j-bg"
        v-if="showContent"
        @click="handleMaskClick"
        :class="panend ? 'pop-wrap-transition' : false"
        :style="coverStyle"
      ></div>
    </transition>
    <transition name="slide-up" @after-leave="handleLeave">
      <section
        ref="section"
        v-if="showContent"
        class="select-wrapper"
        :class="panend ? 'pop-wrap-transition' : false"
        :style="sectionStyle"
      >
        <header ref="header" class="select-header" :class="$platformClass">
          <slot name="select-header"></slot>
        </header>
        <div class="select-content" :class="$platformClass" v-selectHeightFix>
          <slot name="select-content"></slot>
        </div>
      </section>
    </transition>
  </div>
</template>
<style>
.bg {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(0, 0, 0, 0.6);
}
.select-wrapper {
  z-index: 2;
}
.select-content > ul.ocean-ui-list {
  padding-bottom: 80px;
}
</style>

<script>
// 异形屏适配(手机导航栏未隐藏) --- 上述padding-bottom
import selectHeightFix from '../../diractives/store/selectHeightFix';
import Hammer from 'hammerjs';
export default {
  name: 'select-container',
  props: ['showChildSelect'],
  directives: { selectHeightFix },
  data() {
    return {
      showContent: false,
      panend: false,
      hammer: null,
      coverStyle: '',
      sectionStyle: '',
    };
  },
  methods: {
    handleMaskClick() {
      this.panend = false;
      this.$refs.section.style = '';
      this.$refs.cover.style = '';
      this.$nextTick(() => {
        this.showContent = false;
      });
    },
    handleLeave() {
      this.close();
    },
    close() {
      this.$emit('closeSelectContainer');
    },
    // pan手势
    handlePanEvent() {
      let $header = this.$refs.header;
      let $section = this.$refs.section;
      let hammer = new Hammer($header);
      this.hammer = hammer;
      hammer.get('pan').set({ direction: Hammer.DIRECTION_VERTICAL });
      hammer.on('pandown panup', ev => {
        if (ev.deltaY < 0) {
          const scrollUpY = ev.deltaY / 80;
          const scaleX = -ev.deltaY / 10000 + 1;
          this.sectionStyle = `transform: scale(${scaleX}) translateY(${scrollUpY}px)`;
          return;
        }

        const opacity = 1 - ev.deltaY / 1024;
        this.coverStyle = `opacity: ${opacity}`;

        const scrollY = ev.deltaY * 1.2;
        this.sectionStyle = `transform: translateY(${scrollY}px)`;
      });
      hammer.on('panstart', () => {
        this.panend = false;
      });
      hammer.on('panend', ev => {
        this.panend = true;
        this.$nextTick(() => {
          if (ev.deltaY > Math.floor($section.clientHeight / 3)) {
            this.coverStyle = 'opacity: 0';
            this.sectionStyle = 'transform: translateY(100%)';
            this.$nextTick(() => {
              this.showContent = false;
            });
          } else {
            this.coverStyle = 'opacity: 1';
            this.sectionStyle = 'transform: translateY(0)';
          }
        });
      });
    },
  },
  mounted() {
    this.showContent = true;
    this.$nextTick(() => {
      this.handlePanEvent();
    });
  },
  beforeDestroy() {
    this.showContent = false;
    this.hammer.destroy();
  },
};
</script>
